import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Body from './Body/Body';
import Cell from './Cell/Cell';
import Header from './Header/Header';
import HeaderCell from './HeaderCell/HeaderCell';
import Row from './Row/Row';

import classes from './Table.module.scss';

class Table extends React.Component {
  static Body = Body;
  static Cell = Cell;
  static Header = Header;
  static HeaderCell = HeaderCell;
  static Row = Row;

  render() {
    const { children, className, striped, fixed, ...other } = this.props;

    return (
      <table
        cellPadding="0"
        cellSpacing="0"
        className={cn(classes.table, className, {
          [classes.striped]: striped,
          [classes.fixed]: fixed
        })}
        {...other}
      >
        {children}
      </table>
    );
  }
}

Table.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  striped: PropTypes.bool,
  fixed: PropTypes.bool
};

export default Table;
